import sanitizeHtml from "@gpp-ui/html-sanitizer";
import { defaultConfig, getGlobalSanitizeConfig, setGlobalSanitizeConfig } from "./config.js";
import { updateSanitizeConfig } from "./updateConfig.js";
import { createVHtmlDirective } from "./directive.js";
import { defineNuxtPlugin, useRuntimeConfig } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const pluginOptions = runtimeConfig.public?.sanitizerHtml || {};
  setGlobalSanitizeConfig({ ...defaultConfig, ...pluginOptions });
  const globalConfig = getGlobalSanitizeConfig();
  const sanitizeHtmlGlobalConfig = (html) => sanitizeHtml(html, globalConfig);
  nuxtApp.vueApp.directive("html-gpp", createVHtmlDirective(sanitizeHtmlGlobalConfig, globalConfig.customModes));
  return {
    provide: {
      sanitizeHtml: sanitizeHtmlGlobalConfig,
      updateSanitizeConfig
    }
  };
});
